import { createAction, props } from '@ngrx/store';
import { DataSource } from '@sharedModule/models/data-source.model';
import { RecipientListInterface } from '../types/recipient-list';
import { RecipientListFilter } from '../types/recipient-list-filter';

export const fetchRecipientList = createAction(
  '[Recipient List] Recipient List Fetch',
  props<{ filter?: RecipientListFilter }>()
);

export const updateRecipientListFilter = createAction(
  '[Recipient Filter] Recipient List update filter',
  props<{ filter?: RecipientListFilter }>()
);

export const loadedRecipientList = createAction(
  '[Recipient List] Recipient List Loaded',
  props<{ dataSource: DataSource<RecipientListInterface[]> }>()
);

export const failedRecipientList = createAction(
  '[Recipient List] Recipient List Failed'
);

export const deleteRecipient = createAction(
  '[Recipient List] Delete Recipient',
  props<{ partner_id: number; sender_id: number; bene_id: number }>()
);

export const resetRecipientList = createAction(
  '[Recipient List] Reset Recipient List'
);
